import React, { useCallback, useEffect, useRef } from 'react'
import autoComplete from '@tarekraafat/autocomplete.js'
import '@tarekraafat/autocomplete.js/dist/css/autoComplete.css'
import './autocomplete.scss'
import PropTypes from 'prop-types'

const Autocomplete = ({ data, onSelect, name, id }) => {
  const autoCompleteRef = useRef(null)
  const callBackForSelect = useCallback((value) => {
    onSelect(value)
  }, [onSelect])

  const createAutoComplete = useCallback(() => {
    setTimeout(() => {
      if (autoCompleteRef.current || id?.length === 0) return
      // eslint-disable-next-line new-cap
      autoCompleteRef.current = new autoComplete({
        selector: `#${id}`,
        placeHolder: '',
        data: {
          src: data || [],
          keys: ['name']
        },
        resultItem: {
          highlight: true
        },
        events: {
          input: {
            selection: (event) => {
              const selectedValue = event.detail.selection.value
              autoCompleteRef.current.input.value = selectedValue.name
              callBackForSelect(selectedValue)
            }
          }
        }
      })
    }, 0)
    return () => {
      if (autoCompleteRef.current) {
        autoCompleteRef.current = null
      }
    }
  }, [data, callBackForSelect, id])

  useEffect(() => {
    if (data.length > 0) {
      createAutoComplete()
    }
  }, [data, createAutoComplete])

  return (
    <input id={`${id}`} name={name} type='search' dir='ltr' spellCheck={false} autoCorrect='off' autoComplete='off' autoCapitalize='off' />
  )
}

Autocomplete.propTypes = {
  data: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  name: PropTypes.string,
  id: PropTypes.string
}

export default Autocomplete
